/* eslint-disable max-len */
import * as React from 'react';
import { emporiModule } from '@empori/util';
import { LoadingSkeleton } from './components/skeletons';
import { HandleTripsConfig, JournalSourceType } from './types';

export function render(element: JSX.Element, container: Element | DocumentFragment | null) {
  import(/* webpackChunkName: "create-root" */'react-dom/client')
    .then(r => {
      if (!container) {
        return;
      }

      r.createRoot(container).render(element);
    });
}

const HandleTrips = React.lazy(() => import(/* webpackChunkName: "module-handle-trips" */'./modules/handle-trips/handleTrips'));
const LoginWindow = React.lazy(() => import(/* webpackChunkName: "login-window" */'./login/loginWindow'));
const NewPassword = React.lazy(() => import(/* webpackChunkName: "login-window" */'./login/newPassword'));
const ColorSchemeSwitcher = React.lazy(() => import(/* webpackChunkName: "color-scheme-switcher" */'./components/colorSchemeSwitcher'));
const DepartmentSelector = React.lazy(() => import(/* webpackChunkName: "department-selector" */'./components/departmentSelector'));
const UserEditor = React.lazy(() => import(/* webpackChunkName: "user-editor" */'./components/userEditor'));
const MonthlyReports = React.lazy(() => import(/* webpackChunkName: "module-my-monthly-reports" */'./modules/monthly-reports/monthlyReports'));
const Administration = React.lazy(() => import(/* webpackChunkName: "module-administration" */'./modules/administration/administration'));
const DriverSettings = React.lazy(() => import(/* webpackChunkName: "module-driver-settings" */'./modules/driver-settings/driverSettings'));
const MySettings = React.lazy(() => import(/* webpackChunkName: "module-my-settings" */'./modules/driver-settings/mySettings'));
const MyProfile = React.lazy(() => import(/* webpackChunkName: "module-my-profile" */'./modules/my-profile/myProfile'));
const VehicleInspection = React.lazy(() => import(/* webpackChunkName: "module-vehicle-inspection" */'./modules/vehicle-inspection/vehicleInspection'));
const HeaderSearch = React.lazy(() => import(/* webpackChunkName: "module-header-search" */'./components/headerSearch'));

emporiModule('empori2maLoaded', {
  empori2ma: {
    InitTranslations() {
      import(/* webpackChunkName: "init-translations" */'./lang').then(fn => fn.default());
    },
    InitLogin(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <LoginWindow />
        </React.Suspense>, el
      );
    },
    InitNewPassword(el: HTMLElement, email: string) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <NewPassword email={email} />
        </React.Suspense>, el
      );
    },
    InitColorSchemeSwitcher(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <ColorSchemeSwitcher />
        </React.Suspense>, el
      );
    },
    InitDepartmentSelector(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <DepartmentSelector />
        </React.Suspense>, el
      );
    },
    InitUserEditor(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <UserEditor />
        </React.Suspense>, el
      );
    },
    InitHandleTrips(el: HTMLElement, config: HandleTripsConfig) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <HandleTrips {...config} />
        </React.Suspense>, el
      );
    },
    InitMyTrips(el: HTMLElement, config: HandleTripsConfig) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <HandleTrips {...config} />
        </React.Suspense>, el
      );
    },
    InitMonthlyReports(el: HTMLElement, source: JournalSourceType) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <MonthlyReports source={source} />
        </React.Suspense>, el
      );
    },
    InitAdministration(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <Administration />
        </React.Suspense>, el
      );
    },
    InitDriverSettings(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <DriverSettings />
        </React.Suspense>, el
      );
    },
    InitMySettings(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <MySettings />
        </React.Suspense>, el
      );
    },
    InitMyProfile(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <MyProfile />
        </React.Suspense>, el
      );
    },
    InitVehicleInspection(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <VehicleInspection />
        </React.Suspense>, el
      );
    },
    InitHeaderSearch(el: HTMLElement) {
      render(
        <React.Suspense fallback={<LoadingSkeleton />}>
          <HeaderSearch />
        </React.Suspense>, el
      );
    },
    InitAdvertising(el: HTMLElement) {
      import(/* webpackChunkName: "advertising-window" */'./fns/advertisingWindow')
        .then(fn => fn.default(el));
    },
    InitNavigation(el: HTMLElement) {
      import(/* webpackChunkName: "alter-navigation" */'./fns/alterNavigation')
        .then(fn => fn.default(el));
    }
  }
});